/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import axios from "axios";

import { errorHandler, options } from "./index";
import types from "../actions/types";
import { API_URL } from "../config";
import { updateUserProjects, updateUserTools } from "./users";
import getTheUserState from "../utils/userState";
import { toast_notifications } from "../utils/notifications";

const userState = getTheUserState();
const user = userState?.user;

export function createProject(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/project/create", body, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // dispatch({
        // 	type: types.SIGN_IN,
        // 	message: 'Welcome. Successfully sign in!',
        // 	user: response.data,
        // });
        toast_notifications.success("Successfully created project!");
        dispatch(updateUserProjects(user));
        dispatch(updateUserTools(user));
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateProject(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/project/update", body, "post"));
      // console.log( 'responseOK...........................' )
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // dispatch({
        // 	type: types.SIGN_IN,
        // 	message: 'Welcome. Successfully sign in!',
        // 	user: response.data,
        // });
        toast_notifications.success("Successfully edited project!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getProjects() {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/project/getAll", {}, "get"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        await dispatch({
          type: types.GET_ALL_PROJECTS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function postProjectByUserId(userData) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/project/getByUserId", userData, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        await dispatch({
          type: types.GET_PROJECTS_BY_USER_ID,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function getProjectByUserId(data) {
  return async (dispatch) => {
    try {
      const params = { userId: data.get("userId") };
      const response = await axios(options(API_URL + "/project/getByUserId", {}, "get", params));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        await dispatch({
          type: types.GET_PROJECTS_BY_USER_ID,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export async function updateProjectsAndToolsByUserId(data) {
  const dataArray = data;

  const response = await axios(
    options(API_URL + "/project/updateProjectsAndToolsByUserId", dataArray, "post")
  );
  // const responseOK = response && response.status === 200 && response.statusText === "OK";
  // if (responseOK) {
  //   // await dispatch({
  //   //   type: types.GET_PROJECTS_BY_USER_ID,
  //   //   payload: response.data,
  //   // });
  // }
  // if (response.status === 200) {
  //   actions.showNotification(`${response.data.message}`, true, true, "success");
  // } else if (response.status === 201) {
  //   actions.showNotification(`${response.data.message}`, true, true, "info");
  // }
  return response;
}

export function updateArchivedStatus(data) {
  return async (dispatch) => {
    try {
      const body = data;
      const response = await axios(options(API_URL + "/project/archivedStatus", body, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        if (response.data?.data?.archived === true) {
          toast_notifications.success("Successfully archived project!");
        } else {
          toast_notifications.success("Successfully unarchived project!");
        }
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function getProjectByUserAndProjectId(data) {
  return async (dispatch) => {
    try {
      const params = data;
      const response = await axios(
        options(API_URL + "/project/getProjectByUserAndProjectId", {}, "get", params)
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // await dispatch({
        //   type: types.GET_PROJECTS_BY_USER_ID,
        //   payload: response.data,
        // });

        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function updateProjectFavoriteStatus(data) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/project/updateIsFavoriteStatus", { data }, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // await dispatch({
        //   type: types.GET_PROJECTS_BY_USER_ID,
        //   payload: response.data,
        // });
        console.log("RESPONSE", response);
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function deleteProject(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/project/delete", { data }, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Successfully removed project!");
      } else {
        toast_notifications.warning("There was an error!");
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function getProjectsByCompanyId(companyID) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/project/getProjectsByCompanyId", {}, "get", { company_id: companyID })
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export const projectService = {
  getProjectById: (data) => axios(options(API_URL + "/project/getProjectByUserAndProjectId", {}, "get", data)),
  updateProjectFavoriteStatus: (data) => axios(options(API_URL + "/project/updateIsFavoriteStatus", { data }, "post")),
  updateProjectArchived: (data) => axios(options(API_URL + "/project/archivedStatus", data, "post")),
  getProjectCompanyIdAndTeamId: (data) => axios(options(API_URL + "/project/projectByCompanyIdAndTeamId", {}, "get", data)),
  getProjectWithAllCompanies: (data) => axios(options(API_URL + "/project/projectWithAllCompanies", {}, "get", data)),
  fetchProjectsByUserId: (data) => axios(options(API_URL + "/project/getProjectsByUserId", {}, "get", data)),
  deleteProject: (data) => axios(options(API_URL + "/project/delete", { data }, "post")),
};
